import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_kenticokontentnuxtmodule_0e7efae8 from 'nuxt_plugin_kenticokontentnuxtmodule_0e7efae8' // Source: ./deliveryclient/kentico-kontent-nuxt-module.js (mode: 'all')
import nuxt_plugin_kenticokontentconfig_285a2f8a from 'nuxt_plugin_kenticokontentconfig_285a2f8a' // Source: ./deliveryclient/kenticokontent-config.js (mode: 'all')
import nuxt_plugin_googletagmanager_61e83fb0 from 'nuxt_plugin_googletagmanager_61e83fb0' // Source: ./google-tag-manager.js (mode: 'client')
import nuxt_plugin_veevalidate_7e8fecfe from 'nuxt_plugin_veevalidate_7e8fecfe' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_axios_e08464ec from 'nuxt_plugin_axios_e08464ec' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_globalcomponents_91a8526c from 'nuxt_plugin_globalcomponents_91a8526c' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_vue2googlemaps_94a82780 from 'nuxt_plugin_vue2googlemaps_94a82780' // Source: ../plugins/vue2-google-maps (mode: 'all')
import nuxt_plugin_scrolllock_181fe2e2 from 'nuxt_plugin_scrolllock_181fe2e2' // Source: ../plugins/scroll-lock.js (mode: 'client')
import nuxt_plugin_vuescrollto_53dc20e5 from 'nuxt_plugin_vuescrollto_53dc20e5' // Source: ../plugins/vue-scrollto (mode: 'client')
import nuxt_plugin_clickoutside_433d7cda from 'nuxt_plugin_clickoutside_433d7cda' // Source: ../plugins/clickoutside (mode: 'client')
import nuxt_plugin_scrollanimation_a67955be from 'nuxt_plugin_scrollanimation_a67955be' // Source: ../plugins/scrollanimation (mode: 'client')
import nuxt_plugin_scrollentrance_b2117b12 from 'nuxt_plugin_scrollentrance_b2117b12' // Source: ../plugins/scroll-entrance.js (mode: 'client')
import nuxt_plugin_nuxtswiperplugin_622602ba from 'nuxt_plugin_nuxtswiperplugin_622602ba' // Source: ../plugins/nuxt-swiper-plugin.js (mode: 'client')
import nuxt_plugin_vuejsmodal_f50827f4 from 'nuxt_plugin_vuejsmodal_f50827f4' // Source: ../plugins/vue-js-modal (mode: 'client')
import nuxt_plugin_validate_c33f42e8 from 'nuxt_plugin_validate_c33f42e8' // Source: ../plugins/validate (mode: 'client')
import nuxt_plugin_lazysizes_63bafee8 from 'nuxt_plugin_lazysizes_63bafee8' // Source: ../plugins/lazysizes (mode: 'client')
import nuxt_plugin_routeAfter_81d3adee from 'nuxt_plugin_routeAfter_81d3adee' // Source: ../plugins/routeAfter (mode: 'client')
import nuxt_plugin_visible_02a1243c from 'nuxt_plugin_visible_02a1243c' // Source: ../plugins/visible (mode: 'client')
import nuxt_plugin_vtooltip_74057214 from 'nuxt_plugin_vtooltip_74057214' // Source: ../plugins/v-tooltip (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"link":[{"rel":"apple-touch-icon","sizes":"57x57","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"https:\u002F\u002Fwww.thecollective.com\u002Fapple-icon-180x180.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"https:\u002F\u002Fwww.thecollective.com\u002Fandroid-icon-192x192.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"https:\u002F\u002Fwww.thecollective.com\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"https:\u002F\u002Fwww.thecollective.com\u002Ffavicon-96x96.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"https:\u002F\u002Fwww.thecollective.com\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"https:\u002F\u002Fwww.thecollective.com\u002Fmanifest.json"},{"rel":"preload","as":"font","href":"https:\u002F\u002Fwww.thecollective.com\u002Ffonts\u002Fcollective\u002Fcollective-medium.woff2","type":"font\u002Fwoff2","crossorigin":"crossorigin"},{"rel":"preload","as":"font","href":"https:\u002F\u002Fwww.thecollective.com\u002Ffonts\u002Frelative\u002Frelative-book.woff2","type":"font\u002Fwoff2","crossorigin":"crossorigin"},{"rel":"preload","as":"font","href":"https:\u002F\u002Fwww.thecollective.com\u002Ffonts\u002Frelative\u002Frelative-faux.woff2","type":"font\u002Fwoff2","crossorigin":"crossorigin"}],"meta":[{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"https:\u002F\u002Fwww.thecollective.com\u002Fms-icon-144x144.png"},{"name":"theme-color","content":"#ffffff"}],"style":[],"script":[{"src":"\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=GTM-KBRT9S7&l=dataLayer","async":true}],"noscript":[{"hid":"gtm-noscript","innerHTML":"\u003Ciframe src=\"\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KBRT9S7&l=dataLayer\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","pbody":true}],"__dangerouslyDisableSanitizersByTagID":{"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_kenticokontentnuxtmodule_0e7efae8 === 'function') {
    await nuxt_plugin_kenticokontentnuxtmodule_0e7efae8(app.context, inject)
  }

  if (typeof nuxt_plugin_kenticokontentconfig_285a2f8a === 'function') {
    await nuxt_plugin_kenticokontentconfig_285a2f8a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googletagmanager_61e83fb0 === 'function') {
    await nuxt_plugin_googletagmanager_61e83fb0(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_7e8fecfe === 'function') {
    await nuxt_plugin_veevalidate_7e8fecfe(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_e08464ec === 'function') {
    await nuxt_plugin_axios_e08464ec(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91a8526c === 'function') {
    await nuxt_plugin_globalcomponents_91a8526c(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2googlemaps_94a82780 === 'function') {
    await nuxt_plugin_vue2googlemaps_94a82780(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrolllock_181fe2e2 === 'function') {
    await nuxt_plugin_scrolllock_181fe2e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_53dc20e5 === 'function') {
    await nuxt_plugin_vuescrollto_53dc20e5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickoutside_433d7cda === 'function') {
    await nuxt_plugin_clickoutside_433d7cda(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollanimation_a67955be === 'function') {
    await nuxt_plugin_scrollanimation_a67955be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollentrance_b2117b12 === 'function') {
    await nuxt_plugin_scrollentrance_b2117b12(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtswiperplugin_622602ba === 'function') {
    await nuxt_plugin_nuxtswiperplugin_622602ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsmodal_f50827f4 === 'function') {
    await nuxt_plugin_vuejsmodal_f50827f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_validate_c33f42e8 === 'function') {
    await nuxt_plugin_validate_c33f42e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazysizes_63bafee8 === 'function') {
    await nuxt_plugin_lazysizes_63bafee8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routeAfter_81d3adee === 'function') {
    await nuxt_plugin_routeAfter_81d3adee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_visible_02a1243c === 'function') {
    await nuxt_plugin_visible_02a1243c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtooltip_74057214 === 'function') {
    await nuxt_plugin_vtooltip_74057214(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
